import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { theme } from "../Styles/theme";
import logo from "../Resources/hadco-staffing-solutions-logo.png";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

export default function HADCOAppBar() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <AppBar
        position="static"
        style={{ backgroundColor: theme.palette.secondary.light }}
      >
        <Toolbar>
          <Typography variant="h6" className={classes.title} >
            <img
              src={logo}
              alt="logo"
              style={{ 
                marginTop: "10px"
              }}
            />
          </Typography>
        </Toolbar>
      </AppBar>
    </div>
  );
}
